import React from "react"
import cx from "classnames"

const Button = ({ children, disabled = false, onclick = () => { }, to, className = "", blank = false, ...props }) => {
  return <button
    disabled={disabled}
    className={cx(className, buttonStyle(props))}
    href={to}
    onClick={() => onclick()}
    target={blank ? '_blank' : '_self'}
    type={props.type ? props.type : ""}
  >
    {children}
  </button >
}

export default Button

export const buttonStyle = ({ medium = false, ghost = false, negative = false }) => {
  return cx("button", {
    "medium": medium,
    "ghost": ghost,
    "negative": negative
  })
}